import SharedContentListContainer from 'containers/SharedContentContainer/SharedContentListContainer';

export const SharedPainpointsListScreen = () => (
  <SharedContentListContainer listType="painpoints" />
);

export default SharedPainpointsListScreen;
